module.exports = __webpack_public_path__ + "img/okProcessed.c82eb9c5.png";